import React from "react"
import PropTypes from "prop-types"

import EmailModalForm from "./components/EmailModalForm/index"
import ModernModal from "shared/components/ModernModal/index"

import styles from "./styles.css"

import iconEnvelope from "../../assets/svg/envelope.svg"

const ModernEmailModal = ({ title, email, isOpen, onClose, onSubmit }) => {
  return (
    <ModernModal
      icon={iconEnvelope}
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      customModalClass={styles.modalClass}
      renderFooter={false}
    >
      <EmailModalForm email={email} onSubmit={onSubmit} onCancel={onClose} />
    </ModernModal>
  )
}

ModernEmailModal.propTypes = {
  t: PropTypes.func,
  title: PropTypes.string,
  email: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  confirmButtonText: PropTypes.string
}

ModernEmailModal.defaultProps = {
  title: null,
  isOpen: false
}

export default ModernEmailModal



// WEBPACK FOOTER //
// ./src/components/ModernEmailModal/index.js